<template>
  <CycleRouteInfoCard />
</template>

<script>
import CycleRouteInfoCard from '@/components/cycleRouteInfoCard.vue';

export default {
  components: {
    CycleRouteInfoCard,
  },
};
</script>

<style></style>
